import { auth } from '../firebase';

const API_BASE = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : (process.env.NODE_ENV === 'development'
    ? 'http://localhost:5005'
    : 'https://doorknockserver-280072100489.us-central1.run.app');

export async function getIdToken(forceRefresh = false) {
  const user = auth.currentUser;
  if (!user) throw new Error('No authenticated user');
  return user.getIdToken(forceRefresh);
}

// Prepend API_BASE to paths starting with /api/ so callers can pass relative
// URLs. Absolute URLs are used as-is.
function resolveUrl(url) {
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('/api/')) return `${API_BASE}${url}`;
  return url;
}

export async function authFetch(url, options = {}) {
  const token = await getIdToken();
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`
  };
  return fetch(resolveUrl(url), { ...options, headers });
}
